<template>
	<div class="cStyle" :class="theme">
		<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
		<div class="cards">
			<div class="card" v-for="(item, index) in styleData" :key="index">
				<img :src="item.img" />
				<div class="content">
					<div class="line" v-if="item.content"></div>
					<div class="text">{{ item.content }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'cStyle1',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
			styleData: [],
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData']),
	},
  watch:{
    language(newVal, oldVal) {
      this.initData()
    }
  },
	mounted() {
		this.initData()
	},
	methods: {
    initData() {
      let data = JSON.parse(this.jsonData.moduleData)
      if (this.language == 'zh') { // 根据语言获取相应数据
        data = JSON.parse(this.jsonData.moduleData)
        this.styleData = JSON.parse(this.jsonData.coStyle1)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
        this.styleData = JSON.parse(this.jsonData.coStyle1Eng)
      }
      console.log(this.styleData)
      this.pageData = data[this.index]
    }
  },
}
</script>

<style lang="scss" scoped>
.red {
	.cStyle {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.purple {
	.cStyle {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.cards {
	margin-top: 58px;
	padding: 0 50px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around; /* 控制主轴上的对齐方式 */
	align-items: stretch; /* 控制交叉轴上的对齐方式 */
	gap: 26px; /* 在Flexbox布局中，使用gap属性来设置元素之间的间隔 */
}

.card {
	position: relative;
	width: 296px;
}
.card img {
	width: 296px;
	height: 222px;
}

.content {
	margin-top: 16px;
	display: flex;
}

.line {
	display: inline-block;
	width: 5px;
	height: 17px;
	margin-top: 2px;
	background: var(--baseColor);
}

.text {
	width: 282px;
	margin-left: 8px;
	font-size: 14px;
	font-weight: 400;
	color: #0a0a0a;
	line-height: 20px;

	display: -webkit-box;
	-webkit-line-clamp: 4; /* 设置显示的行数 */
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis; /* 超出部分显示省略号 */
}

.purple {
	.line {
		background: #7c62a0;
	}
	.text {
		color: #2a234c;
	}
}
.blue {
	.cStyle {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}
	.cards {
		margin-top: 80px;
		padding: 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: center; /* 控制主轴上的对齐方式 */
		align-items: stretch; /* 控制交叉轴上的对齐方式 */
		gap: 46px; /* 在Flexbox布局中，使用gap属性来设置元素之间的间隔 */
	}

	.line {
		background: #3468c4;
	}
}
.yellow {
	.cStyle {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.cards {
		margin-top: 75px;
		padding: 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: center; /* 控制主轴上的对齐方式 */
		align-items: stretch; /* 控制交叉轴上的对齐方式 */
		gap: 46px; /* 在Flexbox布局中，使用gap属性来设置元素之间的间隔 */
	}

	.line {
		background: #eda900;
	}
}
</style>
